import * as types from './types';
import helper from '@/core/helper';

const getters = {
  [types.GET_IN_PROGRESS_CONTENT_ITEMS]: (state) => {
    const {
      newScrapedContent, inProgressContentScrapes,
    } = state;
    if (newScrapedContent.length === 0) return [];
    const inProgressArticles = [];
    if (inProgressContentScrapes.contentItems.length !== 0) {
      inProgressContentScrapes.contentItems.forEach((contentItem) => {
        inProgressArticles.push({
          title: contentItem.url,
          imageUrl: 'loading',
          state: contentItem.status.includes('_') ? contentItem.status.replace('_', ' ') : contentItem.status,
          updatedDate: new Date(),
        });
      });
    }
    return inProgressArticles;
  },
  [types.GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS]: (state, getter) => {
    const {
      newContentItems, contentItemsDisplayProperties, selectedCreativeId,
      newScrapedContent,
    } = state;
    if (newScrapedContent.length === 0 || newContentItems.length === 0) return [];
    if (helper.objLength(contentItemsDisplayProperties) === 0) return newContentItems;
    const successfullyScrapedArticles = [];
    newContentItems.forEach((contentItem) => {
      const tempContentItem = { ...contentItem };
      const itemDisplayProperties = getter.GET_CONTENT_ITEMS_DISPLAY_PROPERTIES(tempContentItem.encodedExternalId, selectedCreativeId);
      if (itemDisplayProperties) {
        tempContentItem.title = itemDisplayProperties.title;
        tempContentItem.imageUrl = itemDisplayProperties.imageFileName || '/images/image-not-found.png';
      }
      successfullyScrapedArticles.push(tempContentItem);
    });
    return successfullyScrapedArticles;
  },
  [types.GET_FAILED_SCRAPED_CONTENT_ITEMS]: (state) => {
    const { newScrapedContent } = state;
    if (!newScrapedContent.length) return [];
    return newScrapedContent.filter((scrapedArticle) => scrapedArticle.status.includes('FAILED'));
  },
  [types.GET_CONTENT_ITEMS_DISPLAY_PROPERTIES]: (state) => (contentItemUuid, creativeId) => {
    const { contentItemsDisplayProperties } = state;
    if (!helper.objLength(contentItemsDisplayProperties) || !creativeId || !contentItemsDisplayProperties[creativeId]) return [];
    return contentItemsDisplayProperties[creativeId][contentItemUuid]?.displayProperties;
  },
  [types.GET_ARTICLES]: (state) => (isDraft) => {
    const { scrapedContent, contentItems } = state;
    if (!scrapedContent.length) {
      return [];
    }
    const articles = scrapedContent
      .map((scrapedArticle) => {
        let contentItem = Array.from(contentItems)
          .find((item) => item.id === scrapedArticle.contentItemId);
        if (contentItem === undefined && state.query === '' && isDraft) {
          contentItem = {
            title: 'Item not found',
            imageUrl: '/images/image-not-found.png',
            url: scrapedArticle.url,
          };
        }
        if (contentItem === undefined) return undefined;
        let edited;
        if (contentItem) {
          edited = contentItem.updatedDate ? helper.parseISOString(contentItem.updatedDate) : 0;
        }
        return {
          ...scrapedArticle,
          ...contentItem,
          edited,
        };
      });
    return articles.filter((item) => item);
  },
  [types.GET_ACTIVE_CREATIVES]: (state) => state.creatives.filter((creative) => creative.paused === false),
  [types.GET_TEMPLATE_OPTIONS]: (state) => {
    if (!state.creativeTemplates.length) {
      return [];
    }
    const templateOptions = [];
    state.creativeTemplates.map((template) => {
      templateOptions.push({ value: template.id, text: `${template.width} x ${template.height}` });
      return template;
    });
    return templateOptions;
  },
  [types.GET_ANNOTATIONS]: (state) => {
    if (!state.currentComments.length) {
      return [];
    }
    return state.currentComments
      .filter((comment) => !!comment.commentLocation)
      .map((comment) => comment.commentLocation);
  },
  [types.GET_CURRENT_SELECTED_CREATIVE]: (state) => {
    if (state.selectedCreativeId === 0 || state.creatives.length === 0) {
      return {};
    }
    const creativeIndex = state.creatives.findIndex((item) => item.id === state.selectedCreativeId);
    return state.creatives[creativeIndex];
  },
  [types.GET_CURRENT_SELECTED_CREATIVE_DISPLAY_COPY]: (state) => (contentItemUuid) => {
    if (state.selectedCreativeId === 0 || Object.keys(state.allDisplayCopy).length === 0 || !contentItemUuid) {
      return {};
    }
    return state.allDisplayCopy?.[contentItemUuid]?.[state.selectedCreativeId] || {};
  },
};

export default getters;
